import { styled } from "styled-components";
import { StyledProps } from "../../common/types";

export const HeaderStyled = styled.header<StyledProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  padding: 20px 40px;
  @media (max-width: 1025px) {
    padding: 20px 10px;
  }
  height: auto;
  min-height: 40px;
  max-height: 800px;
  @media (min-width: 751px) {
    height: auto;
  }
`;

export const SelectVehicleHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  margin-bottom: 15px;
`;

export const SelectVehicleText = styled.div`
  color: #fff;
  font-family: Inter, sans-serif;
  font-size: 20px !important;
  font-style: normal;
  font-weight: 700 !important;
  line-height: 160%;
  @media (max-width: 750px) {
    font-size: 16px !important;
  }
`;

export const ActionButtonsWrapper = styled.div`
  display: flex;
  gap: 15px;
  @media (max-width: 750px) {
    gap: 10px;
  }
`;

export const ActionButton = styled.div`
  display: flex;
  width: auto;
  height: 40px;
  padding: 10px 10px;
  justify-content: center;
  align-items: center;
  gap: 5px;
  aspect-ratio: 1/1;
  border-radius: 24.5px;
  background: #fff;
  cursor: pointer;
`;

export const HeaderTextWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const HeaderText = styled.div`
  width: 100%;
  max-width: 1240px;
  color: white;
`;

export const LogoWrapper = styled.div`
  width: 100px;
  height: 100px;
  display: block !important;
  @media (max-width: 1500px) {
    display: none !important;
  }
`;

export const CartText = styled.div`
  color: #000;
  font-family: Inter, sans-serif;
  font-size: 11px;
  font-style: normal;
  font-weight: 700;
  line-height: 160%;
`;
